import React from 'react';
import { SnackbarProvider } from 'notistack';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';
import 'moment/locale/es';
import GlobalStyles from 'src/components/GlobalStyles';
import ScrollReset from 'src/components/ScrollReset';
import GoogleAnalytics from 'src/components/GoogleAnalytics';
import { AuthProvider } from 'src/contexts/FirebaseAuthContext';
import Copyright from 'src/utils/copyright';
import Routes from 'src/routes';
import { Theme } from './customTheme';
import './App.css';

moment().locale('es');

const App = () => {
  const theme = createTheme(Theme);
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <SnackbarProvider dense maxSnack={3}>
            <AuthProvider>
              <GlobalStyles />
              <ScrollReset />
              <Routes />
              {/*renderRoutes(routes, isNavOpen, setNavOpen, title, setTitle)*/}
              <GoogleAnalytics />
            </AuthProvider>
          </SnackbarProvider>
        </LocalizationProvider>
        <Copyright />
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
